import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const IconComponent = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsxs("g", {
      fill: "currentColor",
      children: [/*#__PURE__*/_jsx("path", {
        d: "m14.4 9-2.56-1.478c.357-.661.671-1.334.931-1.994.328-.832.566-1.635.697-2.362.08-.451.121-.879.114-1.269A5.987 5.987 0 0 1 15 4.447a6 6 0 0 1-.6 4.554ZM9.988.052c.195.026.388.06.58.105-.342.19-.691.438-1.042.733A12.66 12.66 0 0 0 7.83 2.674a18.648 18.648 0 0 0-1.262 1.804l-2.56-1.477A6 6 0 0 1 9.988.05Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "m8.32 5.49-.886-.512a17.63 17.63 0 0 1 1.178-1.681 11.669 11.669 0 0 1 1.56-1.642c.507-.429.957-.699 1.324-.825.367-.126.583-.088.703-.018.12.07.262.237.336.618.074.38.066.906-.052 1.56a11.678 11.678 0 0 1-.642 2.171 17.77 17.77 0 0 1-.867 1.861l-.922-.532-2.1 3.635.83.874h5.071v2h-5.91L.795 5.406l1.409-1.337 4.313 4.543L8.32 5.49ZM2.252 16l2.454-4.25 1.431 1.52L4.561 16H2.252Zm8.384 0L9.48 14h2.31l1.154 2h-2.31Z"
      })]
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export const IconInfrastructureResort16 = createIcon(IconComponent);